export function log(message: string, ...optionalParams: any[]) {
    if (process.env.NODE_ENV !== 'production') {
        // tslint:disable no-console (No need to forbid this, since it's removed from production bundle anyway)
        console.log(message, ...optionalParams);
    }
}
